/* 
Data.js
Responsible for holding the nodes used in Tree.js
Data is in a hierarchical treelike structure
Display window data is located in TreeData.js
 */
import peopleModel from "../assets/svgs/FEFRpeople.svg"
import natureModel from "../assets/svgs/FEFRnature.svg";
import economyModel from "../assets/svgs/FEFReconomy.svg";

export default {
  name: ``,
  children: [
    {
      name: "Nature / Environment",
      imageUrl: natureModel,
      children: [
        { name: "Natural Capital"} ,
        { name: "Supporting services"} ,
        { name: "Regulating services"} ,
        { name: "Provisioning services"} ,
        { name: "Cultural services"} ,
      ]
    },
    { name: 'Economy / Markets',
    imageUrl: economyModel,
      children: [
        { name: 'Bioproducts',
          children: [
            {
              name: 'Wood based products',
            },
            {
              name: 'Non-wood products',
            }

          ] },
        { name: 'Sustainable businesses' },
        { name: 'Bioenergy' },
        { name: 'Sustainable finance' },
        { name: 'Technologies/Innovations' },
        { name: 'Biocities' },
        { name: 'Services' },


      ] 
    },
    {
      name: "People / Communities",
      imageUrl: peopleModel,
      children: [
        { name: "Social capital" } ,
        { name: "Careers" } ,
        { name: "Education" } ,
        { name: "Qualification" } ,
        { name: "Gender aspects" } ,
        { name: "Green jobs" } ,
        { name: "Prosperity" } ,
        { name: "Wellbeing" } ,


/*         { name: "Bioeconomy support services", } ,
        { name: "Knowledge-based services",} ,
        { name: "Natural environment services"} ,
        { name: "Bio-based goods services"} , */
      ]


    },

  ]
};


// WEBPACK FOOTER //
// ./src/data/NodeData.js